import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../styles/BottomNav.css";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeId, tableNo } = useParams();

 
const isMenu = location.pathname.startsWith("/order");
const isCart = location.pathname.startsWith("/cart") || location.pathname.startsWith("/tkwaycart");
  
 
  const isTKWAY = tableNo && tableNo.toUpperCase().includes("TKWAY");

  const handleCartClick = () => {
    if (isTKWAY) {
   
      navigate(`/tkwaycart/${storeId}/${tableNo}`);
    } else {
    
      navigate(`/cart/${storeId}/${tableNo}`);
    }
  };

  const handleMenuClick = () => {
 
    navigate(`/order/${storeId}/${tableNo}`);
  };

  return (
    <div className="bottom-nav">
      <div
        className={`nav-item ${isMenu ? "active" : ""}`}
        onClick={handleMenuClick}
      >
        <img
          src={
            isMenu
              ? "/images/home_active.png"
              : "/images/home.png"
          }
          alt="Home"
        />
      </div>

      <div
        className={`nav-item ${isCart ? "active" : ""}`}
        onClick={handleCartClick}
      >
        <img
          src={
            isCart
              ? "/images/cart_active.png"
              : "/images/cart.png"
          }
          alt="Cart"
        />
      </div>
    </div>
  );
}